export interface IPrivateMarketsFund {
  id: string;
  name: string;
  taggedAt: string;
  // NOTE: PM-149: the only related-data entity that persists Smart Link provenance; every
  // other box marks smart-linked items in session state alone.
  addedViaSmartLink?: boolean;
}

export class PrivateMarketsFund implements IPrivateMarketsFund {
  constructor(
    public id: string,
    public name: string,
    public taggedAt: string,
    public addedViaSmartLink: boolean = false,
  ) {}
}
